var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.propertyPdfInfo.houseInfo
        ? _c("Report", {
            attrs: {
              id: "report-main",
              pdfTimeShow: _vm.pdfTimeShow,
              propertyPdfInfo: _vm.propertyPdfInfo
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "faq" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "title-text" }, [_vm._v("Listing")])
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  {
                    staticClass: "back-button",
                    staticStyle: {
                      "text-decoration": "underline",
                      cursor: "pointer"
                    },
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "el-icon-arrow-left" }),
                    _vm._v("BACK")
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            {
              staticStyle: {
                display: "flex",
                "align-items": "end",
                "margin-top": "15px"
              }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "addNewListingBtn",
                      on: { click: _vm.navigateToAddListing }
                    },
                    [_vm._v("Create New Listing")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-collapse",
                {
                  staticStyle: { "margin-top": "24px" },
                  on: { change: _vm.handleChange },
                  model: {
                    value: _vm.activeNames,
                    callback: function($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames"
                  }
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "1" } },
                    [
                      _c("Listings-Search-Bar", {
                        attrs: { adminRole: this.adminRole },
                        on: { searchTrigger: _vm.triggerSearch }
                      }),
                      _vm._v(" "),
                      _c("template", { slot: "title" }, [
                        _vm._v("Live Listings")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "fontFamily",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.liveListings }
                        },
                        [
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              "min-width": "45",
                              prop: "propertyId",
                              label: "ID"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "companyName", label: "Agency" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "address", label: "Address" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "suburb", label: "Suburb" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              "min-width": "55",
                              prop: "",
                              label: "Listing Date"
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    scope.row.launchDate
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm
                                                .moment(scope.row.launchDate)
                                                .format("DD/MM/YYYY")
                                            )
                                          )
                                        ])
                                      : _vm._e()
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              "min-width": "55",
                              prop: "proertyType",
                              label: "Property Type"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { "min-width": "120", label: "Actions" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-link",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          icon: "el-icon-download"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.exportPdf(
                                              scope.row.propertyId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Export")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v(" | ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-link",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          icon: "el-icon-edit"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClickEditAgent(
                                              scope.row.propertyId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Edit")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v(" | ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "remove-link",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          icon: "el-icon-delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleClickDeleteAgent(
                                              scope.row.propertyId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "divider" }, [
                                      _vm._v(" | ")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "remove-link",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          icon: "el-icon-link"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.viewProperty(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("View")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.total
                        ? _c(
                            "div",
                            { staticClass: "fen" },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.page,
                                  "page-size": 25,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _vm.total
                                },
                                on: {
                                  "size-change": _vm.handleSizeChange,
                                  "current-change": _vm.handleCurrentChange
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "2" } },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v("Live Reservations")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "fontFamily",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.liveReservations }
                        },
                        [
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "propertyId", label: "Property ID" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "apt", label: "Dwelling #" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "address", label: "Address" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "suburb", label: "Suburb" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              prop: "propertyType",
                              label: "Property Type"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "propertyStatus", label: "Status" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { label: "Date" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatUnixTime(
                                            scope.row.reserveTime
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { label: "Buyer" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.buyerFirstName +
                                            " " +
                                            scope.row.buyerSurName
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.buyerEmail))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { label: "Legal Rep." },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.legalCompanyName))
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(scope.row.legalEmail))
                                    ])
                                  ]
                                }
                              }
                            ])
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { "min-width": "120", label: "Actions" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "remove-link",
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          icon: "el-icon-link"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.viewProperty(scope.row)
                                          }
                                        }
                                      },
                                      [_vm._v("View")]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.totalLiveReservations
                        ? _c(
                            "div",
                            { staticClass: "fen" },
                            [
                              _c("el-pagination", {
                                attrs: {
                                  "current-page": _vm.pageLiveReservations,
                                  "page-size": _vm.sizeLiveReservations,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _vm.totalLiveReservations
                                },
                                on: {
                                  "size-change":
                                    _vm.handleSizeChangeLiveReservations,
                                  "current-change":
                                    _vm.handleCurrentChangeLiveReservations
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "3" } },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v("Sold Properties")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "fontFamily",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.soldProperties, stripe: "" }
                        },
                        [
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "id", label: "ID" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "address", label: "Address" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "soldDate", label: "Sold Date" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              prop: "propertyType",
                              label: "Property Type"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "actions", label: "Actions" }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "el-collapse-item",
                    { attrs: { name: "4" } },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v("Past Listings")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          staticClass: "fontFamily",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.pastListings }
                        },
                        [
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "id", label: "ID" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "address", label: "Address" }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              prop: "archiveDate",
                              label: "Archive Date"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: {
                              prop: "propertyType",
                              label: "Property Type"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            staticClass: "fontFamily",
                            attrs: { prop: "actions", label: "Actions" }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "custom-class": "pdfDialog-box",
            visible: _vm.pdfdialogVisible,
            width: "365px"
          },
          on: {
            "update:visible": function($event) {
              _vm.pdfdialogVisible = $event
            }
          }
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _c("span", { staticClass: "pdfDialog-title" }, [
              _vm._v("Export Report")
            ])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "pdfDialog-tip" }, [
            _vm._v("Please select the time period you want to export")
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center"
              }
            },
            [
              _c(
                "div",
                [
                  _c("p", { staticClass: "pdfDialog-tip timeTip" }, [
                    _vm._v("Start Date")
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticClass: "pdf-timepicker",
                    attrs: {
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                      format: "MMM dd, yyyy",
                      "value-format": "yyyy/MM/dd",
                      type: "date",
                      placeholder: "Select..."
                    },
                    model: {
                      value: _vm.startDate,
                      callback: function($$v) {
                        _vm.startDate = $$v
                      },
                      expression: "startDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticStyle: { "margin-top": "45px" } }, [
                _vm._v("-")
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("p", { staticClass: "pdfDialog-tip timeTip" }, [
                    _vm._v("End Date")
                  ]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticClass: "pdf-timepicker",
                    attrs: {
                      clearable: false,
                      "picker-options": _vm.pickerOptions,
                      format: "MMM dd, yyyy",
                      "value-format": "yyyy/MM/dd",
                      type: "date",
                      placeholder: "Select..."
                    },
                    model: {
                      value: _vm.endDate,
                      callback: function($$v) {
                        _vm.endDate = $$v
                      },
                      expression: "endDate"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "exportListingBtn",
                  on: { click: _vm.downloadPdf }
                },
                [_vm._v("Export")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d716eac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d716eac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listing/listings.vue
// module id = null
// module chunks = 